export const getElements = (
  e: string | HTMLElement | null | undefined
): HTMLElement[] => {
  if (e === null || e === undefined) return [];

  if (typeof e === "string") {
    try {
      return Array.from(document.querySelectorAll(e));
    } catch {
      return [];
    }
  }

  return [e];
};
